import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDiceThree = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M12 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1M8 7a1 1 0 1 0 1 1 1 1 0 0 0-1-1m9-5H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5m3 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3Zm-4-2a1 1 0 1 0 1 1 1 1 0 0 0-1-1" />
  </svg>
);
export default SvgDiceThree;
